import { z } from 'zod';
import { responseProposalSchema } from './responses.js';
import { defineEvents } from '@ndrc/app-sdk/events';
import fr from './messages/fr.json' with { type: 'json' };
export const events = defineEvents({
  'reputation.response.proposed': {
    schema: responseProposalSchema,
    journal: { label: fr.socialResponseEvent, importance: 'normal' },
    realtime: true,
  },
  'reputation.changed': {
    schema: z.object({
      id: z.uuid(),
      table: z.enum(['cases', 'watches', 'crises']),
      action: z.enum(['created', 'saved', 'answered', 'closed', 'reopened', 'transition']),
    }),
    journal: { label: fr.changedEvent, importance: 'normal' },
    realtime: true,
  },
});
